import React from 'react';
import PropTypes from "prop-types";

import moment from 'moment';

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';


// react component for creating dynamic tables
import ReactTable from 'react-table';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { reactTableDefaultProps } from 'helpers/reactTable';
import DaumPostcode from 'react-daum-postcode';

import {
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';

import OrgForm from './OrgForm';
import { ORG_STATUS_STRING } from 'constants/org';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    fontWeight: "bold"
  }
};


class OrgManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      addressModalIsOpen: false,
      addressData: null,
      isEdit: false,
    };
  }

  componentDidMount() {
    if (!this.props.orgs) {
      this.props.getOrgsAction();
    }
  }

  requestClose = () => { this.setState({ modalIsOpen: false }) }

  renderOrgForm = () => {
    return <Modal
      isOpen={this.state.modalIsOpen}
      toggle={this.requestClose}
      size='lg'
    >
      <ModalHeader toggle={this.requestClose}>
        {this.state.currentOrg ? '기관정보 수정' : '신규 기관 등록'}
      </ModalHeader>
      <ModalBody>
        <OrgForm
          openAddressModal={() => {
            console.log("let us open address code modal");
            this.setState({ addressModalIsOpen: true });
          }}
          ref={ref => this.orgFormRef = ref}
          org={this.state.currentOrg}
          requestClose={this.requestClose}
          showAlertAction={this.props.showAlertAction}
          getOrgsAction={this.props.getOrgsAction}
          isEdit={this.state.isEdit}
        />
      </ModalBody>
    </Modal>
  }

  handleAddress = (returnData) => {
    this.orgFormRef.handleAddress(returnData);

    this.setState({
      addressModalIsOpen: false,
    });

    console.log(JSON.stringify(returnData));  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  }


  renderPostCode = () => {
    return <Modal
      isOpen={this.state.addressModalIsOpen}
      toggle={() => this.setState({ addressModalIsOpen: false })}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        },
        overlay: {
          // backgroundColor: 'papayawhip',
          zIndex: 100,
        },
      }}
    >
      <DaumPostcode
        onComplete={this.handleAddress}
        style={{ zIndex: 5, backgroundColor: 'red' }}

      />
    </Modal>
  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>기관 관리</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem
                  container
                  direction="row-reverse"
                  alignItems="center"
                  xs={12}>
                  <Button
                    color="primary"
                    onClick={() => {
                      this.setState({
                        uid: null,
                        isEdit: false
                      }, () => this.setState({ modalIsOpen: true, currentOrg: null }));
                    }}>신규 기관 등록</Button>
                </GridItem>
                <GridItem xs={12}>
                  <ReactTable
                    {...reactTableDefaultProps}
                    data={this.props.orgs}
                    columns={[
                      {
                        id: '기관명',
                        Header: "기관명",
                        accessor: d => d.data().기관명
                      },
                      {
                        id: '대표전화',
                        Header: "대표전화",
                        accessor: d => d.data().대표전화
                      },
                      {
                        id: '사업장주소',
                        Header: "사업장주소",
                        accessor: d => d.data().사업장주소
                      },
                      {
                        id: '상태',
                        Header: "상태",
                        accessor: d => ORG_STATUS_STRING[d.data().status]
                      },
                      {
                        id: 'org_code',
                        Header: "기관코드",
                        accessor: d => d.data().org_code
                      },
                      {
                        id: "created_at",
                        Header: "가입일",
                        accessor: d => {
                          const created_at = d.data().created_at;
                          return moment(created_at ? created_at.toDate() : null).format('YYYY-MM-DD')
                        }
                      },
                      {
                        id: "계약시작일",
                        Header: "계약시작일",
                        accessor: d => d.data().계약시작일
                      },
                      {
                        id: "계약종료일",
                        Header: "계약종료일",
                        accessor: d => d.data().계약종료일
                      }
                    ]}
                    getTrProps={(state, rowInfo) => {
                      if (rowInfo && rowInfo.row) {
                        return {
                          onClick: e => {
                            const d = rowInfo.original;
                            this.setState({ modalIsOpen: true, isEdit: true, currentOrg: d })
                          },
                          style: {
                            cursor: 'pointer'
                          }
                        };
                      } else {
                        return {};
                      }
                    }}
                  />
                </GridItem>
              </GridContainer>


            </CardBody>
          </Card>
        </GridItem>
        {
          this.renderOrgForm()
        }
        {
          this.renderPostCode()
        }
      </GridContainer>
    );
  }
}


OrgManager.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    orgs: state.org.orgs
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}


export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(OrgManager);